import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=c0ff826a&scoped=true"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"
import style0 from "./Transport.vue?vue&type=style&index=0&id=c0ff826a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff826a",
  null
  
)

export default component.exports